// Scroll to BFCM product module
function scrollToBFCMModule(button) {
  const bfcmModule = document.querySelector('[data-bfcm-product-module]');
  if (bfcmModule) {
    const offsetTop = bfcmModule.offsetTop;
    window.scrollTo({
      top: offsetTop - 100, // 100px offset from top
      behavior: 'smooth'
    });
  }
}

// Initialize buy now buttons
document.addEventListener("DOMContentLoaded", () => {
  // Handle scroll to BFCM module buttons
  const scrollButtons = document.querySelectorAll('.showroom-shine-section .showroom-shine-button.buy_now[data-scroll-to-bfcm]');
  scrollButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      scrollToBFCMModule(button);
    });
  });
  
  // Initialize buy now buttons using global function (only for buttons without scroll attribute)
  if (window.initBuyNowButtons) {
    const buyNowButtons = document.querySelectorAll('.showroom-shine-section .showroom-shine-button.buy_now:not([data-scroll-to-bfcm])');
    if (buyNowButtons.length > 0) {
      window.initBuyNowButtons('.showroom-shine-section .showroom-shine-button.buy_now:not([data-scroll-to-bfcm])');
    }
  }
});

